import React, { useEffect, useState } from 'react'
import { FaSailboat } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import imlo from './img/lo.jpg'
import imdl from './img/dl.jpg'
import imh from './img/house.png'
import imcar from './img/caricon.svg'
import im2 from './img/icon2.png'

function AboutBanner() {

     const [index, setIndex] = useState(0);

    const data =[
        {img: imlo},
        {img: imdl},
        {img: imh},
        {img: imcar},
        {img: im2},
    ]

    const [fade, setFade] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
        setFade(false); // trigger fade out
        setTimeout(() => {
            setIndex(prev => (prev + 1) % data.length);
            setFade(true); // trigger fade in
        }, 200); // wait for fade-out before changing
        }, 6000);

        return () => clearInterval(interval);
    }, [data.length]);

  return (
        <div className='home_body' >
            <div className='home_body_text' >
                <h1>YOU GET YOUR <span></span> GOODS DELIVERED AS AT PROMISED AND YOU CAN TRACK THE MOVEMENT OF YOUR GOODS IN REAL TIME.</h1> 
              
                <div className='home_body_text_box1' > 
                    <div className='home_body_text_box1_user_images' >
                        <div className='home_body_box1_user1_images' ></div>
                        <div className='home_body_box1_user2_images'></div>
                        <div className='home_body_box1_user3_images'></div>
                    </div>

                    <div className='home_body_text_box1_writeups' >
                        <h1>WELCOME</h1>
                        <p>JOIN US TODAY</p>
                    </div>                   
                </div>

                <div className='banner_main_texts_' >
                    <h1>OUR PEOPLE ARE SOME OF THE BEST HANDS IN THE INDUSTRY</h1>
                </div>

                <div className='banner_main_texts_btns' >
                    <Link to={'/request'} className='banner_main_texts_btn1' >
                        <div className='banner_main_texts_btn1_' >
                            <FaSailboat size={18} color='#fff' />
                        </div>
                        <p>Make a Request</p>
                    </Link>
                </div>
            </div>

           <div className='homebody_banner' >
                {   
                    index === 3 ?
                    <div style={{
                        opacity: fade ? 1 : 0.5,
                        transition: 'opacity 0.1s ease-in-out',
                        lazyLoad: true,
                    }} 
                    className=' homebody_banner_img3'>
                    </div>
                    : index === 4 ?
                    <div style={{
                        opacity: fade ? 1 : 0.5,
                        transition: 'opacity 0.1s ease-in-out',
                        lazyLoad: true,
                    }}  className=' homebody_banner_img4'>
                    </div>
                    : index === 0 ?
                    <div style={{
                        opacity: fade ? 1 : 0.5,
                        transition: 'opacity 0.1s ease-in-out',
                        lazyLoad: true,
                    }}  className=' homebody_banner_img'></div>
                    : index === 1 ?
                    <div style={{
                        opacity: fade ? 1 : 0.5,
                        transition: 'opacity 0.1s ease-in-out',
                        lazyLoad: true,
                    }} className=' homebody_banner_img1'>
                    </div>
                    : index === 2 ?
                    <div style={{
                        opacity: fade ? 1 : 0.5,
                        transition: 'opacity 0.1s ease-in-out',
                        lazyLoad: true,
                    }} className=' homebody_banner_img2'>
                        
                    </div>
                    : null
                }
                <div className='homebody_banner_ovelay' >
                    {   
                    index === 3 ?
                    <div className=' home_banner'>
                        <h3>- Final delivery from a local distribution center.</h3>
                    </div>
                    : index === 4 ?
                    <div className=' home_banner'>
                        <h3>- Fast and time-sensitive delivery services.</h3>
                        <h3>- Guaranteed delivery within a specific timeframe.</h3>
                        <h3>- Priority handling of urgent documents or parcels.</h3>
                    </div>
                    : index === 0 ?
                    <div className=' home_banner'>
                        <h3>- Pickup and delivery within the same country.</h3>
                        <h3>- Options for same-day, next-day, or standard delivery.</h3>
                        <h3>- Door-to-door or depot-to-depot delivery.</h3>
                    </div>
                    : index === 1 ?
                    <div className=' home_banner'>
                        <h3>- Cross-border logistics with customs clearance assistance.</h3>
                        <h3>- Air, sea, and road freight options.</h3>
                        <h3>- Tracking and insurance for international parcels.</h3>
                    </div>
                    : index === 2 ?
                        <div className='home_banner'>
                            <h3>- Temporary or long-term warehousing solutions.</h3>
                            <h3>- Inventory management and order picking.</h3>
                            <h3>- Cross-docking and distribution.</h3>
                        </div>
                    : null
                }
                </div>
           </div>
        </div>
  )
}

export default AboutBanner